import { createComponentStore } from '../../utils/createComponentStore';

const initData = () => ({
  endpoint_url: '',
  body: '',
});

const { getStore, defaultStore } = createComponentStore({
  type: 'slack',
  endpoint: 'slack',
  registryKey: 'slack',
  initData,

  extraActions: (set, get) => ({
    // Backward-compat alias — prefillComponentStores calls setSlackTemplate
    setSlackTemplate: (component) => get().setComponentData(component),

    setEndPointUrl: (endPointUrl) => {
      set((s) => ({ data: { ...s.data, endpoint_url: endPointUrl } }));
    },

    setSlackBody: (body) => {
      set((s) => ({ data: { ...s.data, body } }));
    },

    // Backward-compat alias
    setSlackName: (name) => get().setName(name),
  }),
});

export const getSlackStore = getStore;
export default defaultStore;
